var DataHandler = (() => {
    var _this;

    Number.prototype.pad = function(size) {
        var s = String(this);
        while (s.length < (size || 2)) {
            s = `0${s}`;
        }
        return s;
    };

    function flattenObject(obj, parentKey, result) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                var newKey = parentKey ? `${parentKey}.${key}` : key;

                if (_this.isDateTimeObject(obj[key])) {
                    result[newKey] = _this.formatDateTimeObject(obj[key]);
                } else if (_this.isDateObject(obj[key])) {
                    result[newKey] = _this.formatDateObject(obj[key]);
                } else if (_this.isTimeObject(obj[key])) {
                    result[newKey] = _this.formatTimeObject(obj[key]);
                } else if ((typeof obj[key] === 'object') && (obj[key] !== null)) {
                    if (Array.isArray(obj[key])) {
                        obj[key].forEach((item, index) => {
                            const arrayKey = `${newKey}.${index}`;
                            if ((typeof item === 'object') && (item !== null)) {
                                flattenObject(item, arrayKey, result);
                            } else {
                                result[arrayKey] = item;
                            }
                        });
                    } else {
                        flattenObject(obj[key], newKey, result);
                    }
                } else {
                    result[newKey] = obj[key];
                }
            }
        }
        return result;
    }

	function shortId(length) {
		let chars;
		let out;
		let cryptoObj;
		let values;
		let i;
		let r;

		if (!length) {
			length = 14;
		}

		chars = '123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		out = '';
		cryptoObj = window.crypto || window.msCrypto;

		if (cryptoObj && cryptoObj.getRandomValues) {
			values = new Uint32Array(length);
			cryptoObj.getRandomValues(values);

			for (i = 0; i < length; i++) {
				out += `${chars[values[i] % chars.length]}`;
			}

			return out;
		}

		// Fallback: mixed entropy, no shared seed
		r = Date.now() ^ (performance && performance.now ? performance.now() * 1000000 : 0);

		for (i = 0; i < length; i++) {
			r ^= Math.random() * 0xFFFFFFFF;
			r = (r << 13) | (r >>> 19);
			out += `${chars[Math.abs(r) % chars.length]}`;
		}

		return out;
	}

    _this = {
        id: function() {
            return shortId();
        },

        isObjectOrArray: function (obj) {
            return obj && (Array.isArray(obj) || (typeof obj === 'object'));
        },

        isDateTimeObject: function(obj) {
            return _this.isDateObject(obj) && _this.isTimeObject(obj);
        },

        isDateObject: function(obj) {
            return obj && (typeof obj === 'object') && obj.hasOwnProperty('year') && obj.hasOwnProperty('month') && obj.hasOwnProperty('day');
        },

        isTimeObject: function(obj) {
            return obj && (typeof obj === 'object') && obj.hasOwnProperty('hour') && obj.hasOwnProperty('minute');
        },

        cloneObject: function (obj) {
            if (!_this.isObjectOrArray(obj)) {
                return null;
            }
            return JSON.parse(JSON.stringify(obj));
        },

        flattenObject: function (obj) {
            if (!_this.isObjectOrArray(obj)) {
                return obj;
            }
            return flattenObject(_this.cloneObject(obj), '', {});
        },

        arrayToObject: function(array, filterFunc) {
            var obj;
            obj = {};
            if (Array.isArray(array)) {
                array.forEach(item => {
                    if (filterFunc && !filterFunc.call(item)) {
                        return;
                    }
                    if (obj.hasOwnProperty(item)) {
                        console.warn(`Overwriting property: ${item}`);
                    }
                    obj[item] = item;
                });
            }
            return obj;
        },

        arrayToAssoc: function(objectsArray, idKey, filterFunc) {
            var obj;
            obj = {};
            if (Array.isArray(objectsArray)) {
                objectsArray.forEach(item => {
                    if (filterFunc && !filterFunc.call(item)) {
                        return;
                    }
                    if (obj.hasOwnProperty(item[idKey])) {
                        console.warn(`Overwriting property: ${item}`);
                    }
                    obj[item[idKey]] = item;
                });
            }
            return obj;
        },

        arrayToOptions: function(objectsArray, idKey, valueKey, filterFunc) {
            var options;
            options = {};
            if (Array.isArray(objectsArray)) {
                objectsArray.forEach(item => {
                    if (filterFunc && !filterFunc.call(item)) {
                        return;
                    }
                    if (options.hasOwnProperty(item[idKey])) {
                        console.warn(`Overwriting property: ${item}`);
                    }
                    options[item[idKey]] = (valueKey instanceof Function) ? valueKey.call(item) : item[valueKey];
                });
            }
            return options;
        },

        arrayToOptGroups: function(objectsArray, idKey, valueKey, filterFunc, optgroupIdKey, optgroupValueKey, optgroupFilterFunc) {
            var optgroups;
            optgroups = {};
            if (Array.isArray(objectsArray)) {
                objectsArray.forEach(item => {
                    if (optgroupFilterFunc && !optgroupFilterFunc.call(item)) {
                        return;
                    }
                    if (!optgroups.hasOwnProperty(item[optgroupIdKey])) {
                        optgroups[item[optgroupIdKey]] = {
                            label: (optgroupValueKey instanceof Function) ? optgroupValueKey.call(item) : item[optgroupValueKey],
                            optionsRaw: []
                        };
                    }
                    optgroups[item[optgroupIdKey]].optionsRaw.push(item);
                });
                Object.values(optgroups).forEach(optgroup => {
                    optgroup.options = _this.arrayToOptions(optgroup.optionsRaw, idKey, valueKey, filterFunc);
                    delete optgroup.optionsRaw;
                });
            }
            return Object.values(optgroups);
        },

        formatDateTimeObject: function(obj) {
            return `${_this.formatDateObject(obj)} ${_this.formatTimeObject(obj)}`;
        },

        formatDateObject: function(obj) {
            if (obj === null) {
                return '00.00.0000';
            }
            if (!_this.isDateObject(obj)) {
                console.warn('Invalid date object.', obj);
                return '??.??.????';
            }
            return `${Number(obj.day).pad(2)}.${Number(obj.month).pad(2)}.${Number(obj.year).pad(4)}`;
        },

        formatTimeObject: function(obj) {
            if (obj === null) {
                return '00:00';
            }
            if (!_this.isTimeObject(obj)) {
                console.warn('Invalid time object.', obj);
                return '??:??';
            }
            return `${Number(obj.hour).pad(2)}:${Number(obj.minute).pad(2)}`;
        }
    };

    return _this;
})();
